/** Routes that should never show the public site global loader. */
export function isNoLoaderRoute(pathname = '') {
  const path = String(pathname || '');
  return path === '/maintenance' || path.startsWith('/admin');
}
